webpackJsonp([49678535319980],{

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'constants/ActionTypes.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This file is where you should store any custom ActionTypes required for your application, ActionTypes that don\'t fit within the standard framework conventions.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Alternatively, if you have disabled blueprints, you would need to specify all of the ActionTypes for the application here.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      export default {\n        // ADD_MODEL:    \'ADD_MODEL\',\n        // UPDATE_MODEL: \'UPDATE_MODEL\',\n        // REMOVE_MODEL: \'REMOVE_MODEL\',\n        // FETCH_MODELS: \'FETCH_MODELS\',\n        // FETCH_MODEL:  \'FETCH_MODEL\'\n      };\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-src-constants-action-types-js-dfb0e7bf40ce79d1446b.js